import _ from "lodash"

/**
 *
 * @param {number} numberOfPages
 * @param {number} maxPages
 * @param {number} activePage
 * @returns
 */
export function calculateInitalPage(numberOfPages, maxPages, activePage) {
  const PAGE_START = 1
  const PAGE_END = numberOfPages

  if (numberOfPages <= maxPages) {
    return PAGE_START
  }

  const boundary = Math.floor(maxPages / 2)
  if (activePage <= PAGE_START + boundary) {
    return PAGE_START
  }
  if (activePage >= PAGE_END - boundary) {
    return PAGE_START + numberOfPages - maxPages
  }

  return activePage - boundary
}

export function getNumberedPages(numberOfPages, maxPages, activePage) {
  const numberOfPagesToDisplay = Math.min(numberOfPages, maxPages)

  const initialPage = calculateInitalPage(numberOfPages, maxPages, activePage)
  const pages = []
  _.times(numberOfPagesToDisplay, number => {
    pages.push(initialPage + number)
  })

  return pages
}
